<template>
  <div>
    <div v-for="studio in Object.keys(data)" :key="studio">
      <div class="title">
      <p>{{studio}}</p>
      </div>
      <vue-glide
        class="demo"
        ref="slider"
        type="carousel"
        :perView="2"
        focusAt="center"
        :key="studio"
      >
        <vue-glide-slide v-for="photo in data[studio]" :key="photo">
          <div class="photoStudios">
            <img class="imageReno" :src="getImage(photo, studio)"/>
          </div>
        </vue-glide-slide>
        <template slot="control">
          <button
            class="slider__arrow slider__arrow--prev glide__arrow glide__arrow--prev"
            data-glide-dir="<"
          >
            &lt;
          </button>
          <button
            class="slider__arrow slider__arrow--next glide__arrow glide__arrow--next"
            data-glide-dir=">"
          >
            &gt;
          </button>
        </template>
      </vue-glide>
    </div>
  </div>
</template>

<script>
import data from "../data/dataMobilier.json";

let p = {};
export default {
  name: "Mobilier",

  data() {
    return {
      data: data,
    };
  },
  methods: {
    getImage: function(photo) {
      return require(`../assets/mobilier/${photo}`);
    },
  },
};
</script>
<style scoped>
.title {
  margin: auto;
}
.category {
  margin-bottom: 40px;
}
.line {
  width: calc(69% / 2);
}
@media only screen and (min-width: 320px) and (max-width: 812px) {
  .line {
    width: calc(62% / 2);
  }
  .innerSpan {
    width: 100px;
  }
}
</style>
